// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"23ebe279","419":"e24eadfd","563":"a578f0d1","778":"2c418a6d","787":"e494d21d","942":"95e1bc19"}[chunkId] + ".chunk.js";
};